import jwtDecode from 'jwt-decode';
import TokenStore from 'donny-auth';
import reduxStore from './redux/store';
import {getOtp} from './selectors';

const stores = new Map();
const tokens = new WeakMap();

const getToken = store => {
  if (!tokens.has(store)) {
    tokens.set(store, store.getToken({aud: 'vizia.brandwatch.com/foot-gun'}));
    setTimeout(() => tokens.delete(store), 10000);
  }
  return tokens.get(store);
};

function getStore(otp = getOtp(reduxStore.getState())) {
  let store = stores.get(otp);

  if (store) {
    return store;
  }

  if (otp === null) {
    store = Promise.resolve(new TokenStore(window.env.AUTH_STORE_DOMAIN));
  } else {
    store = TokenStore.fromOTP(window.env.AUTH_STORE_DOMAIN, otp);
  }

  stores.set(otp, store);

  if (window.Cypress) {
    window.store = store;
  }

  return store;
}

export default {
  init(otp) {
    return getStore(otp);
  },

  isAuthenticated() {
    return getStore().then(getToken);
  },

  getToken() {
    return getStore().then(getToken);
  },

  getUserProfile() {
    return getStore()
      .then(getToken)
      .then(jwtDecode)
      .then(user => Object.assign(user, {name: `${user.firstName} ${user.lastName}`}));
  },

  get store() {
    return getStore();
  },

  hasStore(otp = getOtp(reduxStore.getState())) {
    return stores.has(otp);
  }
};
